import React from 'react';
import Layout from '../components/Layout';
import './Download.css';

const Download = () => {
  return (
    <Layout>
      <section className="download-section">
        <h2>Download Tonometer Scan</h2>
        <p>Get started with Tonometer Scan on your iOS device</p>
        
        <div className="download-options">
          <div className="download-card">
            <h3>🍎 iOS</h3>
            <p>Download from the App Store</p>
            <a 
              href="https://apps.apple.com/app/tonometer-scan" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-badge"
            >
              <img 
                src="/app-store-badge.svg" 
                alt="Download on the App Store" 
                style={{ height: '60px', width: 'auto' }}
              />
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Download;